import {
  Button,
  Flex,
  Modal,
  Divider,
  Space,
  Text,
  LoadingOverlay,
} from "@mantine/core";
import dayjs from "dayjs";
import type { FC } from "react";
import {
  errorShowNotification,
  successShowNotification,
} from "src/lib/mantine";
import { useReactiveAccountMutation } from "src/service/AuthApi";

import styles from "./DeletedAccountMessageModal.module.scss";

export const DeletedAccountMessageModal: FC<{
  reactiveToken: string;
  deletedAt: Date;
  onClose: () => void;
}> = ({ onClose, reactiveToken, deletedAt }) => {
  const [reactive, { isLoading }] = useReactiveAccountMutation();
  const confirm = async () => {
    await reactive({ token: reactiveToken })
      .unwrap()
      .then(() => {
        successShowNotification(
          "アカウントが正常に再活性化されました。再度ログインしてデータを回復できます。",
        );
        onClose();
      })
      .catch(() => {
        errorShowNotification(
          "アカウントの再活性化に失敗しました。後でもう一度お試しください。",
        );
      });
  };

  const remainingDays =
    30 - Math.abs(dayjs(deletedAt).diff(new Date(), "days"));

  return (
    <>
      {!isLoading && (
        <Modal
          opened
          onClose={onClose}
          withCloseButton={false}
          padding={5}
          radius={12}
        >
          <Flex justify="space-between" align="center" p={5}>
            <h4>お知らせ</h4>
          </Flex>
          <Divider />
          <Text mt={16} p={5} pl={10} pr={10} sx={{ lineHeight: "200%" }}>
            あなたのアカウントはロックされています。残り
            <strong>{remainingDays}日</strong>で再度アクティブにできます。
            <ul className={styles.msg}>
              <li>
                あなたのアカウントは完全に削除され、再度ログインすることはできなくなります。
              </li>
              <li>
                あなたに関する情報、投稿記事、受講中のコース、クラスなどもすべて削除されます。
              </li>
              <li>
                削除予定日までの30日間は、アカウントを再び有効化することが可能です。
              </li>
              <li>
                アカウント復活を行うことで、再度ログインが可能になり、削除される前のデータを回復できます。
              </li>
            </ul>
          </Text>

          <Space h={20} />
          <Divider />
          <Space h={10} />
          <Flex align="center" w="100%" gap={8} justify="center">
            <Button className={styles.modalBackButton} onClick={onClose}>
              戻る
            </Button>
            <Button
              variant="filled"
              type="submit"
              className={styles.modalSubmitButton}
              onClick={confirm}
            >
              アカウント復活
            </Button>
          </Flex>
        </Modal>
      )}

      {isLoading && <LoadingOverlay visible />}
    </>
  );
};
